import React from 'react';
import { Link } from '../../../env';
const Home = () => {
    return (
        <div className='w-full my-40 relative'>
            <div className='w-full flex space-x-4'>
                <div className='w-[60%] 2xl:w-[50%] px-0 2xl:px-5'>
                    <div className='w-full'>
                        <h1 className='poppins-medium text-black px-14 2xl:px-0 text-[20px] 2xl:text-[30px]'>{`Revolutionize Your Engine with IRSystemTuning`}</h1>
                    </div>
                    <div className='w-full mt-4'>
                        <p className='poppins-medium text-black px-14 2xl:px-0 text-[14px] 2xl:text-[20px] text-justify'>
                            {`
                            At the heart of every high-performance vehicle is an engine built to exceed limits. With IRSystemTuning's 
                            remap and tuning software, unleash the true potential of your engine. Our software precisely adjusts various 
                            engine parameters such as fuel injection rates, air to fuel ratios, and ignition timing to boost performance, 
                            enhance efficiency, and improve drivability. Experience a seamless transformation that not only optimizes 
                            power output but also ensures sustainability with improved fuel economy. Whether you're looking to gain more 
                            horsepower or enhance torque, IRSystemTuning provides the tools to fine-tune every aspect of your engine's 
                            functionality. Transform your vehicle with the technology designed to elevate your driving experience, where 
                            every modification is a step towards perfection.
                            `}
                        </p>
                    </div>
                </div>
                <div className='w-[40%] 2xl:w-[50%] flex justify-center items-center'>
                    <img src={`${Link}/assets/Icons/engine2.png`} alt='Engine' className='w-auto px-5 2xl:px-0' />
                </div>
            </div>
            <div className='w-full flex space-x-4 mt-[100px]'>
                <div className='w-[40%] 2xl:w-[50%] flex justify-center items-center'>
                    <img src={`${Link}/assets/Icons/electronin.png`} alt='Electronic' className='w-full 2xl:w-[90%] px-5 2xl:px-0' />
                </div>
                <div className='w-[60%] 2xl:w-[50%] px-0 2xl:px-5'>
                    <div className='w-full'>
                        <h1 className='poppins-medium text-black px-14 2xl:px-0 text-[20px] 2xl:text-[30px]'>{`Advanced CPU-Inspired Vehicle Optimization`}</h1>
                    </div>
                    <div className='w-full mt-4'>
                        <p className='poppins-medium text-black px-14 2xl:px-0 text-[14px] 2xl:text-[20px] text-justify'>
                            {`
                            Transform your vehicle's performance with our software, designed to integrate the precision and 
                            efficiency of CPU technology into automotive enhancement. Our solution redefines engine management, 
                            optimizing fuel efficiency and power output through sophisticated recalibration techniques. By mirroring 
                            the processing power of a CPU, it adjusts critical engine parameters in real-time, ensuring each adjustment 
                            is perfectly tuned to your driving conditions.
                            `}
                        </p>
                        <p className='mt-3 poppins-medium text-black px-14 2xl:px-0 text-[14px] 2xl:text-[20px] text-justify'>
                            {`
                            Experience seamless performance upgrades with our dynamic adaptation algorithms that continuously learn and 
                            adjust to your vehicle’s needs. Safeguard your engine with built-in diagnostics that preemptively detect and 
                            correct inefficiencies, embodying the reliability and foresight of advanced computing. Step into the future 
                            of vehicle tuning with IRSystemTuning Software, where technology and performance converge for unmatched results.
                            `}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
